<template lang="html">

    <section class="banner-historia">

        <div class="container">
            <h2 class="secondary-title">
                {{$t('historia.titulo')}}
            </h2>

            <img src="/static/img/mini-fiesta.png" alt="mini" class="mini-fiesta">


            <router-link class="btn-enviar -enviar-pink -two-lines" :to="$t('enlaces.historia')" v-html="$t('historia.boton')"></router-link>

        </div>

    </section>
   
   </template>
   
   <script lang="js">
 
     export default  {
       name: 'banner-historia',
     }
   </script>
   
   <style scoped lang="scss">
 
   </style>
   


// WEBPACK FOOTER //
// src/components/parts/banner-historia.vue